<section class="ach-card">
  <div class="ach-card__header">
    <div class="ach-card__title">
      <span class="ach-card__icon">
        <app-icon name="credit-card" [size]="18" [strokeWidth]="1.9"></app-icon>
      </span>
      <div>
        <h3>ACH Payment Methods</h3>
        <p>Saved bank accounts for remittance payments.</p>
      </div>
    </div>
    <button type="button" class="ach-card__primary-btn" (click)="toggleForm()">
      <app-icon [name]="showForm ? 'close' : 'plus'" [size]="15" [strokeWidth]="2"></app-icon>
      {{ showForm ? 'Cancel' : 'Add New' }}
    </button>
  </div>

  <form *ngIf="showForm" class="ach-card__form" [formGroup]="form" (ngSubmit)="saveMethod()">
    <div class="ach-card__field">
      <label>Account Holder Name</label>
      <input type="text" formControlName="account_holder_name" placeholder="Enter account holder name" />
      <span *ngIf="form.controls['account_holder_name'].touched && form.controls['account_holder_name'].invalid">
        Account holder name is required.
      </span>
    </div>

    <div class="ach-card__field">
      <label>Bank Name</label>
      <input type="text" formControlName="bank_name" placeholder="Enter bank name" />
      <span *ngIf="form.controls['bank_name'].touched && form.controls['bank_name'].invalid">
        Bank name is required.
      </span>
    </div>

    <div class="ach-card__field">
      <label>Account Type</label>
      <p-dropdown
        formControlName="account_type"
        [options]="accountTypeOptions"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
      ></p-dropdown>
    </div>

    <div class="ach-card__field">
      <label>Account Number</label>
      <input type="text" formControlName="account_number" placeholder="Enter account number" />
      <span *ngIf="form.controls['account_number'].touched && form.controls['account_number'].invalid">
        Account number is required.
      </span>
    </div>

    <div class="ach-card__field">
      <label>Routing Number</label>
      <input type="text" formControlName="routing_number" placeholder="9 digit routing number" maxlength="9" />
      <span *ngIf="form.controls['routing_number'].touched && form.controls['routing_number'].invalid">
        Routing number must be 9 digits.
      </span>
    </div>

    <div class="ach-card__form-actions">
      <button type="button" class="ach-card__secondary-btn" (click)="toggleForm()">Cancel</button>
      <button type="submit" class="ach-card__primary-btn" [disabled]="isSaving">
        Save Method
        <i *ngIf="isSaving" class="fa-spin fas fa-spinner ms-2"></i>
      </button>
    </div>
  </form>

  <div *ngIf="isLoading" class="ach-card__loading">
    <ngx-skeleton-loader
      count="3"
      animation="pulse"
      [theme]="{ height: '56px', 'border-radius': '10px', margin: '0 0 10px' }"
    ></ngx-skeleton-loader>
  </div>

  <div *ngIf="!isLoading && methods.length" class="ach-card__list">
    <div *ngFor="let method of methods" class="ach-card__method">
      <div class="ach-card__bank-icon">
        <app-icon name="building" [size]="18" [strokeWidth]="1.9"></app-icon>
      </div>
      <div class="ach-card__method-main">
        <strong>{{ method.bank_name || '-' }}</strong>
        <span>{{ method.account_holder_name || '-' }}</span>
      </div>
      <div class="ach-card__method-meta">
        <span>{{ accountTypeLabel(method.account_type) }}</span>
        <strong>•••• {{ method.pm_last_four || '-' }}</strong>
      </div>
      <button
        type="button"
        class="ach-card__delete-btn"
        [disabled]="deletingId === method.id"
        (click)="deleteMethod(method)"
        aria-label="Delete ACH payment method"
      >
        <i *ngIf="deletingId === method.id" class="fa-spin fas fa-spinner"></i>
        <app-icon *ngIf="deletingId !== method.id" name="trash" [size]="16" [strokeWidth]="1.9"></app-icon>
      </button>
    </div>
  </div>

  <div *ngIf="!isLoading && !methods.length" class="ach-card__empty">
    <span>
      <app-icon name="credit-card" [size]="20" [strokeWidth]="1.8"></app-icon>
    </span>
    <strong>No ACH payment methods yet</strong>
    <p>Add a saved bank account to use it for remittance payments.</p>
  </div>
</section>
